import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import CollapseGroup from "../../waybee-ui/CollapseGroup";
import ExternalLinks from "./components/ExternalLinks";
import Categories from "./components/Categories";
import AppSettings from "./components/AppSettings";
import ConfigurationService from "../../services/ConfigurationService";
import Texts from "./components/Texts";

class Configuration extends Component {
  constructor() {
    super();
    this.state = {
      links: [],
      categories: []
    };
  }

  componentDidMount() {
    const { setTitle } = this.props;
    setTitle("Configurações");
    this.getLinks();
    this.getCategories();
  }

  getLinks = async () => {
    const links = await ConfigurationService.getMenuLinks();

    const formattedLinks = links
      ? links.map((link, index) => ({
          id: index,
          name: link.name,
          link: link.action.value,
          icon: link.icon,
          public: link.public,
          menu: link.menu,
          inAppLink: link.inAppLink,
          destinationStudent: link.destinationStudent,
          destinationFinantial: link.destinationFinantial,
          destinationPedagogical: link.destinationPedagogical,
          schoolYears: link.schoolYears,
          studentClasses: link.studentClasses,
          studentCourses: link.studentCourses,
          studentSeries: link.studentSeries,
          allCourses: link.allCourses
        }))
      : [];

    this.setState({ links: formattedLinks });
  };

  getCategories = async () => {
    const categories = await ConfigurationService.getCommunicationCategories();
    this.setState({ categories: categories || [] });
  };

  saveLink = async data => {
    await ConfigurationService.saveExternalLinkMenu(data);
  };

  removeLink = async data => {
    await ConfigurationService.saveExternalLinkMenu(data);
  };

  saveCategory = async data => {
    await ConfigurationService.saveCommunicationCategories(data);
    this.getCategories();
  };

  deleteCategory = async id => {
    await ConfigurationService.deleteCommunicationCategory(id);
    this.getCategories();
  };

  render() {
    const { links, categories } = this.state;

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CollapseGroup title="Links">
            <ExternalLinks
              links={links}
              onRemoveLink={this.removeLink}
              onNewLink={this.saveLink}
            />
          </CollapseGroup>
        </Grid>
        <Grid item xs={12}>
          <CollapseGroup title="Categorias de Comunicados">
            <Categories
              categories={categories}
              onDeleteCategory={this.deleteCategory}
              onNewCategory={this.saveCategory}
            />
          </CollapseGroup>
        </Grid>
        <Grid item xs={12}>
          <CollapseGroup title="Configurações do App">
            <AppSettings />
          </CollapseGroup>
        </Grid>
        <Grid item xs={12}>
          <CollapseGroup title="Textos">
            <Texts />
          </CollapseGroup>
        </Grid>
      </Grid>
    );
  }
}

Configuration.propTypes = {
  setTitle: PropTypes.func.isRequired
};

export default Configuration;
